import * as React from 'react';
import * as Tgcc from '../tgccGlobal';
import {Link} from 'react-router';
import Radium, { StyleRoot } from 'radium';


type ScrollProps = {
    children?: any
}

const wrapperStyle : React.CSSProperties = {
    width: '100%',
    height: '100vh',
    overflowY: 'auto',
    overflowX: 'hidden',
    backfaceVisibility: 'hidden',
    willChange: 'overflow'
}

export class _Scroll extends React.Component<ScrollProps, any>{
    
    render(){
        return (
            <div id="Scroller" style={wrapperStyle}>
                    {this.props.children}
            </div>
        )
    }
}


export var Scroll = Radium(_Scroll);